/***
 * 创建人：李珊
 * 时间：2020-12-01
 * 描述: 查看素材详情-编辑素材内容模块
 * 使用说明:
 * 更新说明:
 */
import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { SwCreateModalComponentService } from 'src/app/librarys/serves/sw-create-modal-component.service';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { environment } from 'src/environments/environment';
import { KmsService } from '../../../kms.service';
import { Md5 } from "ts-md5";
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
declare var $;
declare var CKEDITOR: any; 
@Component({
  selector: 'app-material-content-update',
  templateUrl: './material-content-update.component.html',
  styleUrls: ['./material-content-update.component.css']
})
export class MaterialContentUpdateComponent implements OnInit {
  // 素材Id
  @Input() resourceInfo: any = {};
  // 当前页id
  @Input() detailId: string;
  // 删除弹框对象
  @Input() trim:any;
  // 点击取消按钮：抛出事件
  @Output() cancleClick = new EventEmitter();
  // 点击保存按钮：抛出事件
  @Output() saveClick = new EventEmitter();
  //富文本框配置文件
  config: any = {
    uiColor: '#F8F8F8',   // 编辑框背景色
    language: 'zh-cn',  // 显示语言
    toolbarCanCollapse: true,  // 是否可收缩功能栏
    toolbar: [
    ['Source'],
    ['Maximize'],
    ['CopyFormatting','RemoveFormat'],
    ['Undo', 'Redo', '-', 'Cut', ' Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Link', 'Unlink', 'Anchor', '-', 'Table', 'HorizontalRule', 'Smiley', 'SpecialChar', '-'],
    ['Bold', 'Italic', 'Underline', 'Strike', '-', 'Subscript', 'Superscript', '-', 'NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', 'Blockquote'],
    ['Styles', 'Format', 'Font', 'FontSize']],  // 工具部分
    height: 400
  };
  // 当前页数据
  formModel:any = {};
  // 是否允许重新解析
  resolveEnable:boolean = true;
  // 是否正在解析数据
  isResolving = false;
  // 保存按钮是否可用
  clickEnable:boolean = true;
  styleArr:any = [];
  constructor(
    private http: SwHttpClientService,
    private create: SwCreateModalComponentService,
    private box: SwMassageBoxService,
    private kmsService: KmsService
  ) { }

  ngOnInit() {
    this.http.Get('assets/kgs/richBoxTextStyle.json').subscribe((data) => {
      this.styleArr = data.css;
    })
  }

  ngOnChanges() {
    this.clickLoca();
  }

  // 页面初始化
  clickLoca(){
    if(this.resourceInfo && this.detailId){
      // 查询当前页数据
      this.kmsService.queryByDetailId({
        "detailId": this.detailId,
        "materialId": this.resourceInfo.materialId
      }).subscribe(
        data => {
          if (data.code == '200') {
            this.formModel = data.data;
          }else{
            this.box.waring('素材内容信息查询失败！');
          }
        }
      );
      // 根据素材类型和素材来源判断是否可以重新解析(目前支持：图像、文档)
      if((this.resourceInfo.materialCategory == 'FILE_TYPE_PICTURE' || this.resourceInfo.materialCategory == 'FILE_TYPE_DOCUMENT') && this.resourceInfo.accessType != 3){
        this.resolveEnable = true;
      }else{
        this.resolveEnable = false;
      }
    }
  }


  // 重新解析某一页的数据
  nextResolve(){
    this.isResolving = true;
    // let params = {
    //   "checkCode": Md5.hashStr('tygocr'),
    //   "timeStamp": Math.round(new Date().getTime()/1000),
    //   "url": environment.staticFileUrl+this.formModel.filePath
    // }
    let params = {
      "url": 'http://122.112.235.243:9999/'+this.formModel.filePath
    }
    this.kmsService.resolveOnePage(params).subscribe(
      data => {
        this.isResolving = false;
        if (data.code == '200') {
          this.box.success('文字提取成功！');
          this.formModel.materialText = data.data;
        }else{
          this.box.waring('文字提取失败！');
        }
      }
    );
  }

  // 删除本页数据
  deletePage(){
    this.trim.openCLick("确认删除本页数据吗？", (data) => {
      if (data) {
        this.kmsService.deleteMaterialDetail(this.detailId).subscribe(
          res => {
            if(res.code == '200'){
              this.box.success('删除成功！');
              // 更新素材索引
              let params = {
                "materialId": this.resourceInfo.materialId,
                "pagesNum": this.formModel.pagesNum
              }
              this.kmsService.addPageIndex(params).subscribe(
                  data => {
                      console.log(data.msg);
                  }
              )
              this.saveClick.emit(true);
            }
          }
        )
      }
    })
  }

  // 提交
  onSubmit({ value, valid }, event: Event) {
    this.clickEnable = false;
    this.kmsService.updateMaterialDetail(this.formModel).subscribe(
      data => {
        this.clickEnable = true;
        if(data.code == '200'){
          this.box.success('保存成功！');
          this.saveClick.emit(true);
        }else{
          this.box.waring('素材内容保存失败！');
        }
      }
    );
  }

  // 插入选项
  insertItem(n){
    CKEDITOR.config.allowedContent = true;
    // 获取当前操作的富文本框id
    const id = $('#materialContent1').find('>div').attr('id').replace('cke_','');
    let editor = CKEDITOR.instances[id];
    // 获取当前选中的文本
    let text = editor.getSelection().getSelectedText();
    // 判断是否有选中的文本
    if(text){
        // 给选中的文本添加指定的样式，并覆盖原始选中的数据
        const css = this.styleArr[n].css;
        let parent = $("<a>"+text+"</a>");
        parent.attr('href','javascript:void(0)');
        parent.css(css.style);
        const html = parent[0].outerHTML;
        // const html1 = '<span style="color:#ff0000;border:1px solid #000000">'+text+'</span>';
        editor.insertHtml(html);
    }
}
}
